import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {Router} from '@angular/router';
import {MobilePackComponent} from '../mobile-pack/mobile-pack.component';
import {ApiAmenaService} from '../../services/api-amena.service';
import {ShoppingCartService} from '../../services/shopping-cart-service';
import {NormalizadorService} from '../../services/normalizador.service';
import {MobilePackService} from '../../services/mobile-pack.service';
import {DraftService} from '../../services/draft.service';
import {GeneralService} from '../../services/general.service';
import {UserDataService} from '../../services/user-data.service';
import {ResultadoService} from '../../services/resultado.service';
import {TerminalDeliveryService} from '../../services/terminal-delivery.service';
import {AmenaListener} from '../../interface/amena-listener';
import {RateListener} from '../../interface/rate-listener';
import {LandlineConfigurationListener} from '../../interface/landline-configuration-listener';
import {Rate} from '../../interface/rate';
import {LandlineConfigurationModel} from '../../interface/landline-configuration-model';
import {TerminalDeliveryModel} from '../../interface/terminal-delivery-model';
import {DigoService} from "../../../services/digo.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-amena',
    templateUrl: './amena.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./amena.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class AmenaComponent implements OnInit, AfterViewInit, AmenaListener, RateListener, LandlineConfigurationListener, OnDestroy {
    @ViewChild('stepper') myStepper: MatStepper;
    @ViewChild(MobilePackComponent) mobilePackComponent;

    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;
    fourthFormGroup: FormGroup;
    customerFormGroup: FormGroup;
    DataNormalizacion: any;
    muestraNormalizacion = true;
    muestraLoading: boolean;
    isEditable: boolean;
    router: string;
    // Mobile Pack
    form: FormArray;
    maxMobilePacks = 5;
    rateAccess: any;
    realtechnology: any;
    rate: Rate;
    landlineConfiguration: LandlineConfigurationModel;
    mySubscription: any;
    isUserValidation: boolean;
    public muestraErrorPeticion: boolean = false;
    public msgErrorPeticion: any;
    public terminalDelivery: TerminalDeliveryModel;
    public clientIsCover: boolean = false;
    public migrationData: any;
    public environment = environment;

    constructor(
        private digoService: DigoService,
        private amenaService: ApiAmenaService,
        private formBuilder: FormBuilder,
        private shoppingCartService: ShoppingCartService,
        private normalizadorService: NormalizadorService,
        private mobilePackService: MobilePackService,
        private draftService: DraftService,
        private generalService: GeneralService,
        private userDataService: UserDataService,
        private resultadoService: ResultadoService,
        private terminalDeliveryService: TerminalDeliveryService,
        private _router: Router
    ) {
        this.router = _router.url;
        if (this.environment.production) {
            this.normalizadorService.setClientIsCover(true);
        }
    }

    ngOnInit() {
        this.getPDV();
        this.initForms();
        this.amenaService.getStaircaseTypesFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    data.msg.sort(this.compare);
                    this.amenaService.setStaircaseTypes(data.msg);
                }
            });

        this.amenaService.getFloorTypesFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    data.msg.sort(this.compare);
                    this.amenaService.setFloorTypes(data.msg);
                }
            });

        this.amenaService.getDocumentTypesFromService()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    this.amenaService.setDocumentTypes(data.msg);
                }
            })            

        // Recuperamos valores para el select de tipo de vía
        this.normalizadorService.getRoadTypesFromService()
            .subscribe((data) => {
                this.amenaService.setDatosTipoVia(data['msg']);
            }, (error) => {
                console.error(error);
            });

        // Recuperamos valores para el select de tipo de vía
        this.normalizadorService.getProvinciasFromService()
            .subscribe((data: any) => {
                this.amenaService.setProvincias(data['msg']);
            }, (error) => {
                console.error(error);
            });

        // Actualizamos el valor de la vista cuando hay cambios
        this.normalizadorService.getMuestraNormalizacion()
            .subscribe((value) => {
                this.muestraNormalizacion = value;

                if (this.muestraNormalizacion) {
                    this.rate = null;
                }
            });

        // Errores petición http o direcciones vacias
        this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value) => {
                this.muestraErrorPeticion = value;
            });

        this.normalizadorService.getMsgErrorCobertura()
            .subscribe((value) => {
                this.msgErrorPeticion = value;
            });

        this.normalizadorService.getTiposDeAcceso()
            .subscribe(data => {
                this.rateAccess = data;
            });

        this.normalizadorService.getRealtechnology()
            .subscribe(data => {
                this.realtechnology = data;
                console.log('realtechnology', this.realtechnology);
            });

        this.mobilePackService.getRate()
            .subscribe(data => {
                if (data != null) {
                    this.rate = data;
                }
            });

        this.draftService.getActivacionCompletada()
            .subscribe(data => {
                this.isEditable = data;
            });

        this.mobilePackService.getIndexToRemove()
            .subscribe(data => {
                if (data != null) {
                    this.removeAdditionalLine(data);
                }
            });

        this.userDataService.getUserValidation()
            .subscribe(data => {
                this.isUserValidation = data;
            });

        this.normalizadorService.getClientIsCover()
            .subscribe((value: any) => {
                this.clientIsCover = value;
            });

        this.amenaService.getMigrationData()
            .subscribe((value: any) => {
                this.migrationData = value;
            });
    }

    ngAfterViewInit() {
        this.shoppingCartService.setStepper(this.myStepper);
        this.amenaService.getPDV()
            .subscribe(data => {
                if (data != null) {
                    this.getInforFromList();
                }
            });
    }

    public onStepChange(event: any): void {
        this.draftService.saveDraft();
    }

    getPDV() {
        this.digoService.getPdvFromService()
            .subscribe((data: any) => {
                this.amenaService.setPDV(data);
                this.shoppingCartService.setPdv(data);
            });
    }

    getInforFromList() {
        this.generalService.getEmptyFormMobilePack()
            .subscribe(data => {
                if (data != null && data.length > 0) {
                    data.forEach((value, index) => {
                        if (value.principal && this.rate == null) {
                            this.rate = value.rate;
                        } else if (this.secondFormGroup.controls.form.value.length < data.length) {
                            this.addNewMobilePack(false);
                        }
                    });
                }
            });
    }

    initForms() {
        this.firstFormGroup = this.formBuilder.group({
            firstCtrl: ['', Validators.required]
        });

        this.secondFormGroup = this.formBuilder.group({
            form: this.formBuilder.array([this.initMobilePack()])
        });

        this.thirdFormGroup = this.formBuilder.group({
            thirdCtrl: ['', Validators.required]
        });

        this.fourthFormGroup = this.formBuilder.group({
            fourthCtrl: ['', Validators.required]
        });

        this.customerFormGroup = this.formBuilder.group({
            customer_doctype: ['', Validators.required],
            customer_doc: ['', Validators.required]
        });
    }

    initMobilePack() {
        return this.formBuilder.group({
            secondCtrl: ['', Validators.required],
        });
    }

    addItem(next: boolean = true) {
        this.form = this.secondFormGroup.get('form') as FormArray;
        this.form.push(this.initMobilePack());

        if (next) {
            setTimeout(() => {
                this.myStepper.next();
            });
        }
    }

    addNewMobilePack(next: boolean = true) {
        if (this.secondFormGroup.controls.form.value.length < this.maxMobilePacks) {
            this.addItem(next);
        }
    }

    removeAdditionalLine(index) {
        if (index !== 0) {
            this.myStepper.previous();
            this.form = this.secondFormGroup.get('form') as FormArray;
            this.form.removeAt(index);
        }
    }

    isAvailableToAdd(): boolean {
        return !this.migrationData && (this.secondFormGroup.controls.form.value.length < this.maxMobilePacks);
    }

    onSelectRate(rate: Rate) {
        this.mobilePackService.setRate(rate);
        this.rate = rate;

        const mobilePackForm = this.formBuilder.group({
            type_operation: ['registration', Validators.required],
            rate: [this.rate, Validators.required],
            portability_phone: [''],
            portability_operator: [''],
            portability_type_client: [''],
            portability_iccid: [''],
            portability_client: [''],
            iccid: [''],
            terminal: [''],
            terminal_payment_type: [''],
            terminal_insurance: [''],
            stepper_index: [1]
        });

        this.generalService.setFormularioMobilePack(mobilePackForm);
    }

    editRate() {
        this.rate = null;
    }

    // LandlineConfigurationListener
    onSuccessfulValidation(model: LandlineConfigurationModel) {
        this.firstFormGroup.get('firstCtrl').patchValue(true);

        this.landlineConfiguration = model;
        this.myStepper.next();
    }

    ngOnDestroy() {
        console.log('DESTROY AMENA COMPONENT');
        this.mobilePackComponent.resetForm();
        this.form = null;
        this.myStepper.reset();
        // Borramos valores seteados en los observables
        this.normalizadorService.resetNormalizacion();
        this.normalizadorService.setRealtechnology(null);
        this.normalizadorService.setTiposDeAcceso(null);
        this.mobilePackService.setRate(null);
        this.mobilePackService.setIsModalSimOpen(false);
        this.userDataService.setUserData(null);
        this.userDataService.setUserValidation(false);
        this.generalService.resetForms();
        this.generalService.resetEmptyForms();
        this.terminalDeliveryService.setTerminalDelivery(null);
        // Reiniciamos draft limpiamos carrito
        this.draftService.orderInit();
        this.shoppingCartService.clearShoppinCart();
        this.mobilePackComponent.rate = null;
        this.generalService.setEmptyFormTerminalDelivery(null);
        this.generalService.setEmptyFormNormalizacion(null);
        this.resultadoService.setDatosEdicion(null);

        this.normalizadorService.setClientIsCover(false);
        this.amenaService.setMigrationData(null);
    }

    compare(a, b) {
        if (a.code < b.code) {
            return -1;
        }

        if (a.code > b.code) {
            return 1;
        }

        return 0;
    }
}
